import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Alert,
  Box,
  Checkbox,
  FormControlLabel,
  Stack,
  TextField,
} from '@mui/material'
import { useAuth } from '~/api/auth'
import { Button, Title } from '~/components'

const Login = () => {
  const { login } = useAuth({
    middleware: 'guest',
    // redirectIfAuthenticated: '/',
  })
  const { t } = useTranslation()
  const [errorMessage, setErrorMessage] = useState()

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault()
      const data = Object.fromEntries(new FormData(e.target).entries())
      await login({
        setErrorMessage,
        ...data,
      })
    },
    [login]
  )

  return (
    <div className="flex justify-center items-center">
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{ maxWidth: '400px', width: '100%' }}
        onSubmit={onSubmit}
      >
        <Stack spacing={4}>
          <Title>{t('auth.login.title')}</Title>
          <Stack spacing={2}>
            <TextField label={t('auth.email')} name="email" type="email" />
            <TextField
              label={t('auth.password')}
              name="password"
              type="password"
            />
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <FormControlLabel
                control={<Checkbox />}
                label={t('auth.remember')}
                name="remember"
              />
              <Button
                size="small"
                to="/forgot-password"
                variant="text"
                style={{ marginTop: '0.25em', textTransform: 'none' }}
              >
                {t('auth.forgot')}
              </Button>
            </Stack>
            <Button variant="contained" type="submit">
              {t('auth.login.cta')}
            </Button>
            {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
          </Stack>
        </Stack>
      </Box>
    </div>
  )
}

export default Login
